// Mint-Settings · Cài đặt cá nhân: dữ liệu mẫu theo script board (fixtures, chưa ghi DB).

export const SECS = [
  ['profile', 'Hồ sơ & ghế'], ['look', 'Giao diện'], ['ask', 'Ask HANA'], ['security', 'Bảo mật'], ['desk', 'Bàn làm việc & ghế'],
  ['tools', 'Tiện ích & góp ý'], ['noti', 'Thông báo'], ['backup', 'Backup & uỷ quyền'], ['sessions', 'Phiên & thiết bị'], ['keys', 'Phím tắt'],
] as const;
export type SecKey = (typeof SECS)[number][0];
export const SEC_N: Partial<Record<SecKey, number>> = { noti: 7, sessions: 4 };

export interface Seat { code: string; name: string; type: string; since: string; tone: 'pri' | 'warn' | 'mute' }
export const SEATS: readonly Seat[] = [
  { code: 'SALE-MGR', name: 'Trưởng phòng Kinh doanh', type: 'Chính', since: '26/Jul/2026', tone: 'pri' },
  { code: 'BOD-DDIR', name: 'Phó Giám đốc', type: 'Quyền (Acting)', since: '01/Oct/2026', tone: 'warn' },
  { code: 'ADMIN', name: 'Quản trị hệ thống (cờ kỹ thuật)', type: 'Cờ kỹ thuật', since: '', tone: 'mute' },
];

export const NOTI = [
  { id: 'p0', k: 'Khẩn P0 · K1–K5, sự cố xe, cont lạnh', sub: 'Luôn bật push + Zalo — không tắt được', def: [1, 1, 0], locked: true },
  { id: 'task', k: 'Việc tới hạn & quá hạn', sub: 'Task của tôi và người tôi đang thay', def: [1, 0, 1], locked: false },
  { id: 'appr', k: 'Duyệt chờ tôi', sub: 'Release còn nợ, giá dưới sàn, đề nghị thanh toán, nghỉ phép', def: [1, 1, 1], locked: false },
  { id: 'mail', k: 'Mail được gắn PIC cho tôi', sub: 'info@ · support@', def: [1, 0, 0], locked: false },
  { id: 'vsl', k: 'Tàu đổi lịch / cut-off', sub: 'Job tôi phụ trách', def: [1, 1, 0], locked: false },
  { id: 'debt', k: 'Công nợ quá hạn', sub: 'Khách tôi phụ trách', def: [0, 0, 1], locked: false },
  { id: 'digest', k: 'Tóm tắt đầu ngày của Ask HANA', sub: '07:30 mỗi ngày làm việc', def: [1, 0, 1], locked: false },
] as const;
export const CHANNELS = ['Push', 'Zalo', 'Email'] as const;

export const BACKUPS = [
  { seat: 'SALE-MGR', scope: 'Duyệt margin, chuyển khách, release trong hạn mức', def: 'TUANNT', opts: [['TUANNT', 'Sale · 12 việc'], ['ANDG', 'Sale · 18 việc'], ['PHILIP', 'Giám đốc']] },
  { seat: 'BOD-DDIR', scope: 'Duyệt cấp BOD', def: 'PHILIP', opts: [['PHILIP', 'Giám đốc']] },
  { seat: 'Khách của tôi', scope: '14 khách · job, báo giá, mail support@', def: 'ANDG', opts: [['ANDG', 'Sale · 18 việc'], ['TUANNT', 'Sale · 12 việc']] },
] as const;

export interface Deleg { id: number; dir: 'Tôi giao' | 'Giao cho tôi'; k: string; when: string }
export const DELEGS0: readonly Deleg[] = [
  { id: 1, dir: 'Tôi giao', k: 'BOD-DDIR → PHILIP', when: '24/Oct/2026 08:00 → 25/Oct/2026 17:30 · nghỉ phép' },
  { id: 2, dir: 'Giao cho tôi', k: 'TUANNT (SALE-SE) → DAVID · 6 khách', when: '22/Oct/2026 → 23/Oct/2026 · TUANNT vắng đột xuất' },
];

export const SESSIONS = [
  { k: 'Windows · Chrome 131', where: '235 Cộng Hòa, Tân Bình · đang dùng', cur: true, reg: false },
  { k: 'iPhone 15 · HANA Ezy', where: 'TP.HCM · 2 giờ trước', cur: false, reg: true },
  { k: 'iPad Air · HANA Ezy', where: 'TP.HCM · hôm qua', cur: false, reg: false },
  { k: 'MacBook · Edge', where: 'Hà Nội · 6 ngày trước', cur: false, reg: false },
] as const;

export const KEYS: readonly (readonly [string, readonly string[]])[] = [
  ['Tìm nhanh mọi nơi', ['Ctrl', 'K']], ['Tạo mới trên màn hiện tại', ['N']], ['Thu gọn / mở menu', ['[']], ['Mở cột phải', [']']],
  ['Đổi Chuẩn / Gọn', ['Ctrl', '.']], ['Chuyển sáng / tối', ['Ctrl', 'Shift', 'L']], ['Mở Việc của tôi', ['G', 'V']], ['Mở HANA Box', ['G', 'B']],
];

export const HANA_PLUS = [['chat', 'Chat Ask HANA', true], ['quote', 'Soạn báo giá', true], ['docs', 'Đọc chứng từ', true], ['inbox', 'Phân loại mail', false], ['handover', 'Bàn giao khi nghỉ', false]] as const;
export const PASSKEYS = [['Windows Hello · máy này', 'tạo 01/Oct/2026 · dùng lần cuối hôm nay 08:02'], ['iPhone 15 · Face ID', 'tạo 12/Sep/2026 · dùng lần cuối hôm qua']] as const;
export const DEVICES = [['iPhone 15 · HANA Ezy', 'đăng ký 12/Sep/2026 · nhận lần cuối 08:41'], ['Windows · Chrome 131', 'máy này · đăng ký 01/Oct/2026'], ['iPad Air · HANA Ezy', 'đăng ký 20/Aug/2026 · 3 ngày chưa nhận']] as const;
export const MAILBOXES = [['info@', 'booking-confirm, arrival notice', 42], ['support@', 'khách hỏi, hoá đơn vào', 17], ['trf@', 'sự cố xe, lệnh vận tải', 5]] as const;
export const DESK_CARDS = ['Việc hôm nay', 'Duyệt chờ tôi', 'Cut-off tuần', 'Tàu đổi lịch', 'Khách cần follow', 'Tin nội bộ'] as const;
export const DOCK0 = ['Việc', 'HANA Box', 'Ask HANA', 'Lịch tàu', 'My Files'] as const;

/** Đổi chỗ phần tử i với i+d (ngoài biên giữ nguyên). */
export function moveItem<T>(a: readonly T[], i: number, d: number): T[] {
  const j = i + d;
  const r = a.slice();
  if (j < 0 || j >= r.length) return r;
  [r[i], r[j]] = [r[j]!, r[i]!];
  return r;
}

/** Trạng thái bật của một ô thông báo: ô khoá P0 luôn bật; còn lại theo ghi đè rồi mặc định. */
export function notiOn(n: (typeof NOTI)[number], ci: number, ov: Readonly<Record<string, boolean>>): boolean {
  if (n.locked && n.def[ci] === 1) return true;
  return ov[`${n.id}${ci}`] ?? n.def[ci] === 1;
}

/** Hồ sơ mẫu (tên riêng, email che — không dịch). */
export const USER = { name: 'Nguyễn Trường Giang', code: 'DAVID', mail: 'gi•••@hanalogisticsvn.com' } as const;
/** Nhãn ngôn ngữ giữ nguyên ngôn ngữ của nó. */
export const LANG_LABEL = { vi: 'Tiếng Việt', en: 'English' } as const;
/** Người nhận uỷ quyền mẫu: mã · chức danh. */
export const PEOPLE = [['TUANNT', 'Sale'], ['ANDG', 'Sale'], ['PHILIP', 'Giám đốc']] as const;
export const seatLine = (code: string): string => { const x = SEATS.find((e) => e.code === code); return x ? `${x.code} · ${x.name}` : code; };
